module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/rotate_hover.237e5557.svg";